import { connect } from 'react-redux';

import {
    MinusPhraseLibraryGroupsCountCell,
    MinusPhraseLibraryGroupsCountCellProps
} from '../../components/MinusPhraseLibraryGroupsCountCell/MinusPhraseLibraryGroupsCountCell';
import { GridScreenLinkBuilder } from '../../service/GridScreenLinkBuilder';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

export interface OwnProps {
    groupsCount: number;
    id: string;
}

export type StateProps = TStateProps<
    MinusPhraseLibraryGroupsCountCellProps,
    OwnProps
>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { groupsCount, id } = ownProps;
    const { login } = state.commonData;
    const { campaignsIds } = state.minusPhraseLibrary.gridData;

    return {
        link:
            groupsCount !== 0
                ? GridScreenLinkBuilder.getUrlShowMinusPhrasesBindedGroups(
                      id,
                      campaignsIds,
                      login
                  )
                : undefined
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: {},
    ownProps: OwnProps
): MinusPhraseLibraryGroupsCountCellProps => {
    return {
        ...stateProps,
        ...{ groupsCount: ownProps.groupsCount }
    };
};

export const MinusPhraseLibraryGroupsCountCellContainer = connect<
    StateProps,
    {},
    OwnProps,
    MinusPhraseLibraryGroupsCountCellProps
>(
    mapStateToProps,
    {},
    mergeProps
)(MinusPhraseLibraryGroupsCountCell);
